// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-dialog:not(.v-dialog--fullscreen){max-height:100vh!important}", ""]);
// Exports
module.exports = exports;
